<div tabindex="0" class="mail-box" (blur)="focusOnTable = false">
  <div class="table-wrapper"  infiniteScroll [infiniteScrollDistance]="1"
  [infiniteScrollThrottle]="500" [infiniteScrollDisabled]="loading" [scrollWindow]="false" (scrolled)="onScroll()">
  <table class="mail-table" (click)="focusOnTable=true">
    <thead>
      <tr>
        <th>注力</th>
        <th class="mail-title" [ngClass]="{'mail-title-tight':openMailId!==-1}" (click)="subjectFirst=!subjectFirst">
          <span style="display: flex; justify-content: center; cursor: pointer;">
            <span [ngClass]="subjectFirst? 'subject-first bold':'subject-second'">件名</span>
            <span style="order: 1;">&nbsp;/&nbsp;</span>
            <span [ngClass]="subjectFirst? 'subject-second':'subject-first bold'">キーワード</span>
          </span>
        </th>
        <th
          (click)="senderNameFirst=!senderNameFirst" style="cursor: pointer;">
          <span [ngStyle]="{'font-weight':senderNameFirst?'bolder':'normal'}">名前</span> /
          <span [ngStyle]="{'font-weight':!senderNameFirst?'bolder':'normal'}">送信</span></th>
        <th>
          <div class="header-with-button">
            <span>日時</span>
            <app-sort-button
              [(sortOrder)]="sortParams.date_order"
              (sortOrderChange)="sortOrderChange('date', $event)">
            </app-sort-button>
          </div>
        </th>
        <th>場所</th>
        <th>
          <div class="header-with-button">
            <span>金額</span>
            <app-sort-button
              [(sortOrder)]="sortParams.fee_order"
              (sortOrderChange)="sortOrderChange('fee', $event)">
            </app-sort-button>
          </div>
        </th>
        <th>
          <div class="header-with-button">
            <span>年齢</span>
            <app-sort-button
              [(sortOrder)]="sortParams.age_order"
              (sortOrderChange)="sortOrderChange('age', $event)">
            </app-sort-button>
          </div>
        </th>
        <th>商深</th>
        <th>{{page === pageEnums.project_list?"個人":"雇用"}}</th>
        <th>{{page === pageEnums.project_list?"外国籍":"国籍"}}</th>
        <th>開始</th>
        <th>面談</th>
        <th style="width: 100%;">再送</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mail of mails; let i = index" (click)="clickMail(i)" (dblclick)="openNewTab(i)"
      [ngClass]="{'row-selected': openMailId===i, 'already-read': readMails?.includes(mail.id)}" [id] = "'mailid'+i">
        <td>
          <app-user-focus-star [mailInfo]="mail" [mailType]="mailType" [page]="page"></app-user-focus-star>
        </td>
        <td class="mail-title" [ngClass]="{'mail-title-tight':openMailId!==-1}" [ngbTooltip]="mail.title" [container]="'body'">
          <span>
            <app-tag-area
              [mailType]="mailType" [mailInfo]="mail" [page]="page"
              [offers]="sharedAccountOffers" [offeredMailIds]="offeredMailIds" [searchParams]="searchParams">
            </app-tag-area>
            <ng-container *ngIf="subjectFirst; else keywordsFirst">
              <span>{{ mail.title }}</span> &nbsp;&nbsp;<span class="gray"> {{mail.keywords | englishKeywords}}</span>
            </ng-container>
            <ng-template #keywordsFirst>
              <span>{{mail.keywords | englishKeywords}}</span> &nbsp;&nbsp; <span class="gray">{{ mail.title }}</span>
            </ng-template>
        </span>
        </td>
        <td class="mail-sender" [ngStyle]="{'direction': senderNameFirst? 'ltr':'rtl'}">
          {{ mail.mail_from_name+ '/' +mail.mail_from }}
        </td>
        <td>
          <ng-container *ngIf="!mail.mail_register_id">
            {{ mail.receipt_datetime | date: 'MM/dd HH:mm'}}
          </ng-container>
        </td>
        <td>
          {{ mail.work_location }}
        </td>
        <td [innerHtml]="mail.fee | fee:mail.estimate_fee"></td>
        <td>
          {{ mail.age | age }}
        </td>
        <td>
          {{
            mail.number_of_connect_company
              | modifyNumberOfConnectCompanyForProject
          }}
        </td>
        <td *ngIf="page === pageEnums.project_list; else EmploymentStatusForWorker">
          {{ mail.employment_status | modifyEmploymentStatusTextForProject }}
        </td>
        <ng-template #EmploymentStatusForWorker>
          <td>
            {{ mail.employment_status | modifyEmploymentStatusTextForWorker }}
          </td>
        </ng-template>
        <td>
          {{ mail.country_of_citizenship | checkOutsideOfJapan: mailType }}
        </td>
        <td>
          {{ mail.work_immidiately | modifyWorkImmidiatelyText }}
        </td>
        <td>
          {{ mail.interview_times | modifyInterviewCountText }}
        </td>
        <td>  {{ mail.transmited_number | countReceivedTimes }}</td>
      </tr>

      <ng-container *ngIf = "!loading; else elseContent">
        <tr id="scroll-loading-anchor">
          <td colspan="13" (click)="onScroll()" >
            <i class="fa fa-chevron-down margin-right-5"></i>更に検索<span
            class="font-weight-normal">&emsp; {{ pageNumber*200 }} 件（累積検索数）検索しました。</span>
          </td>
        </tr>
        <tr style="height: 13rem; border: none;"></tr>
      </ng-container>
    </tbody>
  </table>
  </div>

  <div class="detail-box" id="detail"
    *ngIf="openMailId!==-1 && openMailId<mails.length"
    [@closeOpenWidth]="openMailId!==-1 && openMailId<mails.length" tabindex="1"
    >
    <app-card [id]="'mail-detail'"
      [mailInfo]="mails[openMailId]"
      [mailType]="mailType"
      [sharedAccountOffers]="sharedAccountOffers"
      [offeredMailIds]="offeredMailIds"
      [searchParams]="searchParams"
      [page]="page"
      (closeCard)="openMailId=-1">
    </app-card>
  </div>
  <!-- ローディングアニメーション -->
  <ng-template #elseContent>
    <tr id="scroll-loading-anchor"><td colspan="13">計算中...</td></tr>
    <tr style="height: 13rem; border: none;">
      <td colspan="13">
        <div class="loader" style="margin: 0 auto;"></div>
      </td>
    </tr>
  </ng-template>
</div>
